import type { ATPObjective, ATPWeek } from '../services/atpApi';

/** ATP weeks need not start on the calendar's locale-specific first weekday. */
export function calendarWeeklyObjectives(dates: string[], weeks: ATPWeek[], objectives: ATPObjective[]) {
  const visible = new Set(dates.map(date => date.slice(0, 10)));
  return [...weeks].sort((a, b) => a.start_day.localeCompare(b.start_day)).flatMap(week => {
    const start = week.start_day.slice(0, 10);
    const date = new Date(start + 'T12:00:00Z');
    if (!Number.isFinite(date.getTime())) return [];
    let intersects = false;
    for (let day = 0; day < 7; day++) {
      if (visible.has(date.toISOString().slice(0, 10))) intersects = true;
      if (day < 6) date.setUTCDate(date.getUTCDate() + 1);
    }
    if (!intersects) return [];
    let phase: string | undefined;
    try {
      const details = typeof week.details === 'string' ? JSON.parse(week.details) : week.details;
      phase = details?.phase_key;
    } catch { /* Invalid phase metadata must not hide explicit weekly objectives. */ }
    const seen = new Set<string>();
    const goals = objectives.filter(goal => {
      const matches = goal.scope === 'week' ? goal.week_start?.slice(0, 10) === start
        : goal.scope === 'phase' && !!phase && goal.phase_key === phase;
      if (!matches || seen.has(goal.id)) return false;
      seen.add(goal.id);
      return true;
    });
    return goals.length ? [{ start, end: date.toISOString().slice(0, 10), goals }] : [];
  });
}
